import { z } from 'zod';
import { AssetSchema, IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';

export const PersonalPropertyAssetSchema = AssetSchema.and(
  z.object({ idAssetCategory: z.literal(IAssetCategoryId.PersonalProperty) })
);
export type IPersonalPropertyAsset = z.infer<
  typeof PersonalPropertyAssetSchema
>;

export const RealEstateCategoryAssetSchema = AssetSchema.and(
  z.object({ idAssetCategory: z.literal(IAssetCategoryId.RealEstate) })
);
export type IRealEstateCategoryAsset = z.infer<
  typeof RealEstateCategoryAssetSchema
>;

export const LiabilitiesAssetSchema = AssetSchema.and(
  z.object({ idAssetCategory: z.literal(IAssetCategoryId.Liabilities) })
);
export type ILiabilitiesAsset = z.infer<typeof LiabilitiesAssetSchema>;

export const OtherCategoryAssetSchema = AssetSchema.and(
  z.object({ idAssetCategory: z.literal(IAssetCategoryId.Other) })
);
export type IOtherCategoryAsset = z.infer<typeof OtherCategoryAssetSchema>;

export function isPersonalPropertyAssetCategory(
  asset: IAsset
): asset is IPersonalPropertyAsset {
  return asset.idAssetCategory === IAssetCategoryId.PersonalProperty;
}

export function isRealEstateAssetCategory(
  asset: IAsset
): asset is IRealEstateCategoryAsset {
  return asset.idAssetCategory === IAssetCategoryId.RealEstate;
}

export function isLiabilitiesAssetCategory(
  asset: IAsset
): asset is ILiabilitiesAsset {
  return asset.idAssetCategory === IAssetCategoryId.Liabilities;
}
export function isOtherAssetCategory(
  asset: IAsset
): asset is IOtherCategoryAsset {
  return asset.idAssetCategory === IAssetCategoryId.Other;
}
